<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>订单管理</span>
                </div>
            </div>
            <div class="search_box">
                <el-form :inline="true" :model="searchData" class="demo-form-inline search-form form-list">
                    <el-form-item label="激活码/订单号/手机号" class="form_item form_item_big">
                        <el-input placeholder="请输入" clearable v-model="searchData.code"></el-input>
                    </el-form-item>
                    <el-form-item label="订单类型" class="form_item">
                        <el-select v-model="searchData.is_cycle" clearable placeholder="订单类型">
                            <el-option label="随心兑" :value="0"></el-option>
                            <el-option label="周期兑" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单状态" class="form_item">
                        <el-select v-model="searchData.redeem_status" clearable placeholder="订单状态">
                            <el-option label="未发货" :value="0"></el-option>
                            <el-option label="已发货" :value="1"></el-option>
                            <el-option label="已取消" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单日期" class="date_picker form_item ">
                        <DatePicker :date="createTime" disabledDate="true" :clearable="true" @dateSelect="createTimeSelect"></DatePicker>
                    </el-form-item> 
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                        <div class="button search export" @click="exportList" v-if="roleCheck('105-102-102-102')">
                            <span>导出</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-table
                highlight-current-row
                :data="listData">
                <el-table-column prop="card_code" label="激活码"></el-table-column>
                <el-table-column prop="redeem_id" label="订单号" ></el-table-column>
                <el-table-column label="订单类型">
                    <template slot-scope="scope" >
                        <span>{{scope.row.is_cycle ? '周期兑' : '随心兑'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="生成时间" >
                    <template slot-scope="scope" >
                        <span>{{formDate(scope.row.create_time)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="redeem_num" label="数量"></el-table-column>
                <el-table-column prop="redeem_name" label="收件人"></el-table-column>
                <el-table-column prop="redeem_address" label="收件地址">
                    <template slot-scope="scope" >
                        <span>{{scope.row.redeem_area + scope.row.redeem_address}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="redeem_phone" label="联系电话"></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope" >
                        <span class="finish" v-if="scope.row.redeem_status === 3">已取消</span>
                        <span class="finish" v-if="scope.row.redeem_status === 2">已完成</span>
                        <span class="send" v-if="scope.row.redeem_status === 1">已发货</span>
                        <span class="unshipped" v-if="scope.row.redeem_status === 0">未发货</span>
                    </template>
                </el-table-column>
                <el-table-column prop="tracking_no" label="物流单号"></el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope" >
                        <div class="button text" @click="cancelOrder(scope.row)" v-if="roleCheck('105-102-102-103') && scope.row.redeem_status === 0">取消</div>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
        </div>
        <Tip ref="tip" title="导出订单" msg="猫砂卡购买订单将直接发往您的飞书邮箱，确认要导出吗？">
            <template v-slot:confirm_btn>
                <div class="button del" @click="exportListConfirm">
                    <span>确定</span>
                </div>
            </template>
        </Tip>
        <Tip ref="orderCancelTip" title="取消订单" :msg="`取消订单后，将恢复兑换额度。 是否要取消订单 ${cancelOrderId} ？`">
            <template v-slot:confirm_btn>
                <div class="button del" @click="cancelOrderConfirm">
                    <span>确定</span>
                </div>
            </template>
        </Tip>
    </div>
    
</template>
<script>
export default({
    name: 'cat-litter-card-order',
    data() {
        return {
            searchData: {
                code: '',
                is_cycle: '',
                redeem_status: '',
                start_time: '',
                end_time: '',
                page: 1,
                page_size: 10
            },
            createTime: [],
            productType: [],
            listData: [],
            total: 0,
            cancelOrderId: ''
        }
    },
    watch: {
        createTime: function(nTime) {
            if(nTime) {
                this.searchData.start_time = nTime[0]/1000;
                this.searchData.end_time =  nTime[1]/1000;
            }else{
                this.searchData.start_time = '';
                this.searchData.end_time = '';
            }
            
        }
    },
    created() {
        this.getList();
    },
    methods: {
        init() {
            this.searchData = {
                sn: '',
                reg_start: '',
                reg_end: '',
                page_size: 10,
                page: 1
            };
            this.buyTime = '';
            this.createTime = '';
        },
        search() {
            this.searchData.page = 1;
            this.getList();
        },
        createTimeSelect(date) {
            this.createTime = date ? [...date] : '';
        },
        getList() {
            const params = {...this.searchData};
            params.redeem_status = params.redeem_status === '' ? -1 : params.redeem_status;
            params.is_cycle = params.is_cycle === '' ? -1 : params.is_cycle;
            this.api.getClcOrderList(params).then(data => {
                this.listData = data.data.list;
                this.total = data.data.total;
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        },
        exportList() {
            // if(!this.createTime || this.createTime.length == 0) {
            //     this.$message('请先选择订单日期');
            //     return;
            // }
            this.$refs.tip.show = true;
        },
        exportListConfirm() {
            this.api.exportClcOrderList().then(() => {
                this.$refs.tip.show = false;
            });
        },
        cancelOrder(list) {
            this.cancelOrderId = list.redeem_id;
            this.$refs.orderCancelTip.show = true;
        },
        cancelOrderConfirm() {
            this.api.cancelClcOrder({redeem_id: this.cancelOrderId}).then(() => {
                this.getList();
                this.$refs.orderCancelTip.show = false;
            })
        }
    }
})
</script>
<style lang="less" scoped>
    .finish{
        color: #F8AF0C;
    }
    .send{
        color: #2A79FF;
    }
    .el-form.form-list{
        /deep/.form_item.form_item_big{
            .el-form-item__label{
                width: 170px;
            }
            .el-input__inner{
                width: 200px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/product/cat-litter-card/order.vue